import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Subheading } from "capitalrx-components-2.0/lib/typography";
import { FC } from "react";
import { ReactComponent as NotFound } from "./NotFound.svg";

export const NoResults: FC<{ readonly message: string, readonly dynamicSize?: boolean }> = ({ message, dynamicSize = false }) => {
  const { imgSize } = useResponsive({
    imgSize: {
      desktop: 300,
      mobile: 200,
    },
  });

  const imgStyle = dynamicSize ? { maxWidth: imgSize, maxHeight: imgSize } : { width: imgSize, height: imgSize };
  return (
    <Stack spacing="none" testId="no-results-container">
      <Shelf>
        <Shelf.Spacer />
        <NotFound style={imgStyle} />
        <Shelf.Spacer />
      </Shelf>
      <div style={{ height: 16 }} />
      <Shelf>
        <Shelf.Spacer />
        <Subheading textAlign="center" testId="no-results-message">{message.replace(/\.$/, "")}</Subheading>
        <Shelf.Spacer />
      </Shelf>
    </Stack>
  );
};
